module.exports = __webpack_public_path__ + "static/media/icon-egg-blue.ab9416b0.jpg";